/** Senarai perubahan yang disahkan untuk pegawai (Fasa 5, pelan Task 11). Placeholder sama dengan cleanup-changes-en.ts. */
export default {
  badge: 'Dibersihkan dengan AI: {{count}} perubahan ({{ai}} dicadangkan oleh AI)',
  title: 'Apa yang telah diubah',
  loading: 'Sedang menyemak senarai perubahan…',
  close: 'Tutup',
  round: 'Pusingan {{n}}',
  before: 'Sebelum',
  after: 'Selepas',
  approvedBy: 'Diluluskan oleh {{name}} pada {{date}}',
  proposedByRule: 'Ditemui oleh peraturan gisify',
  proposedByModel: 'Dicadangkan oleh {{provider}} {{model}}',
  proposedByModelRegion: 'Dicadangkan oleh {{provider}} {{model}} di {{region}}',
  reverted: 'Dibatalkan oleh {{name}} pada {{date}}',
  unknownPerson: 'akaun lain',
  unverified: 'Senarai perubahan ini tidak dapat disahkan, jadi ia tidak dipaparkan.',
  none: 'Senarai perubahan ini tidak merekodkan sebarang perubahan.',
  leftOut: 'Disimpan sebagai AutoCAD 2000',
  listMore: '{{items}} dan {{more}} lagi',
  yes: 'ya',
  no: 'tidak',
  op: {
    rename_layer: 'Menamakan semula lapisan',
    explode_inserts: 'Memecahkan blok kepada bentuknya',
    scale_units: 'Menukar lukisan kepada meter',
    close_outline: 'Menutup garis luar yang jurangnya kurang daripada 1 mm',
    join_pieces: 'Mencantumkan garisan yang bertemu hujung ke hujung menjadi garis luar',
    show_layer: 'Menghidupkan lapisan',
    remove_empty_layer: 'Membuang lapisan kosong',
    remove_degenerate: 'Membuang bentuk sifar panjang',
    remove_duplicate: 'Membuang bentuk pendua',
    text_to_mtext: 'Menyimpan label sebagai teks berbilang baris (perkataannya tidak berubah)',
    choose_site_boundary: 'Memilih sempadan tapak',
    assign_layer: 'Memindahkan lapisan ke lapisan standard',
    assign_shapes: 'Memindahkan bentuk ke lapisan guna tanah',
    set_units: 'Menetapkan unit yang digunakan semasa lukisan dilukis',
    attach_label: 'Melekatkan label pada petak',
    label_plot: 'Memberi petak guna tanahnya',
    remove_layers: 'Membuang lapisan',
    remove_entities: 'Membuang item yang tidak dapat disimpan dalam fail baharu',
  },
  field: {
    layer: 'Lapisan',
    layers: 'Senarai lapisan',
    count: 'Bilangan',
    type: 'Jenis',
    shapes: 'Senarai bentuk',
    shape: 'Bentuk',
    pieces: 'Kepingan',
    outlines: 'Garis luar',
    closed: 'Ditutup',
    on: 'Dihidupkan',
    frozen: 'Dibekukan',
    removed: 'Dibuang',
    text: 'Teks label',
    plot: 'Petak',
    moved: 'Dialihkan',
    classCode: 'Kelas guna tanah',
    candidates: 'Calon',
    entities: 'Item',
    unit: 'Unit ukuran',
    group: 'Kumpulan',
    insunits: 'Kod unit',
    factor: 'Faktor skala',
  },
} as const
